<script setup>
import { ref, inject } from "vue";
import { useStore } from "vuex";

const store = useStore();
const selectedDevices = inject("selectedDevices");

import PermanentDeleteModal from "./Modals/PermanentDelete.vue";
import RestoreDevicesModal from "./Modals/RestoreDevices.vue";

const showPermanentDeleteModal = ref(false);
const showRestoreDevicesModal = ref(false);

const noDevicesWarning = () => {
  store.dispatch("toastNotification/displayToast", {
    message: "No device(s) selected.",
    type: "warning",
    duration: 1500,
  });
};

const openPermanentDeleteModal = () => {
  if (selectedDevices.value.length === 0) {
    noDevicesWarning();
  } else {
    showPermanentDeleteModal.value = true;
  }
};

const openRestoreDevicesModal = () => {
  if (selectedDevices.value.length === 0) {
    noDevicesWarning();
  } else if (selectedDevices.value.length > 1) {
    store.commit("toastNotification/SET_MODAL", {
      title: "Restore devices",
      message: "You can only restore 1 device at a time.",
      type: "warning",
    });
  } else {
    showRestoreDevicesModal.value = true;
  }
};
</script>

<template>
  <div class="col-md-12">
    <PermanentDeleteModal
      v-model="showPermanentDeleteModal"
      @update:modelValue="showPermanentDeleteModal = $event"
    />
    <RestoreDevicesModal
      v-model="showRestoreDevicesModal"
      @update:modelValue="showRestoreDevicesModal = $event"
    />

    <div class="d-flex justify-content-end" style="margin-top: 12px">
      <button
        @click="openPermanentDeleteModal"
        type="button"
        class="btn btn-danger btn-sm"
      >
        PERMANENTLY DELETE DEVICES
        <i class="fa fa-refresh fa-spin" style="display: none"></i>
      </button>
      <button
        @click="openRestoreDevicesModal"
        type="button"
        class="btn btn-success btn-sm"
      >
        RESTORE DELETED DEVICES
      </button>
    </div>
  </div>
</template>
